import React, { useState } from 'react';
import CircleChat from './CircleChat';

// サークル/イベント詳細ページに置くランチャー。
// - オーナー/スタッフ: 「魅力を教える」+「聞く」の2ボタンを並べて表示
// - その他のユーザー: 「聞く」1ボタンのみ
// イベントページから利用する場合も circleId (主催サークルID) を渡してサークルスコープで動作する。
//
// TGW-1161: AI チャットは会員ログイン必須に統一。未ログインユーザーが
// ボタンを押した場合は会員登録ページに誘導する。
export default function ChatLauncher({
  circleId,
  canManage = false,
  userSignedIn = false,
}) {
  const [modalState, setModalState] = useState(null);

  // RN 側 ChatLauncher と揃える (TunaGate-ReactNativeApp/src/components/Chat/ChatLauncher.js)
  const creatorLabel = 'AIにサークルの魅力を伝える';
  const userLabel = 'AIにサークルについて聞く';
  const creatorIconSrc = '/img/chat_ai_human.png';
  const userIconSrc = '/img/chat_ai_only.png';

  const openModal = (mode) => {
    // 未ログインの場合は会員登録ページへ誘導(rurl で戻り先保持)
    if (!userSignedIn) {
      const rurl = encodeURIComponent(window.location.href);
      window.location.href = `/users/sign_up?rurl=${rurl}`;
      return;
    }
    setModalState({ mode });
  };
  const closeModal = () => setModalState(null);

  const templateType = modalState
    ? `circle_knowledge_${modalState.mode}`
    : null;

  return (
    <>
      {canManage ? (
        <div className="cchat-launcher-group">
          <button
            type="button"
            className="cchat-launcher-btn"
            onClick={() => openModal('creator')}
          >
            <img
              src={creatorIconSrc}
              alt=""
              aria-hidden="true"
              className="cchat-launcher-icon"
            />
            <span>{creatorLabel}</span>
          </button>
          <button
            type="button"
            className="cchat-launcher-btn cchat-launcher-btn-secondary"
            onClick={() => openModal('user')}
          >
            <img
              src={userIconSrc}
              alt=""
              aria-hidden="true"
              className="cchat-launcher-icon"
            />
            <span>{userLabel}</span>
          </button>
        </div>
      ) : (
        <button
          type="button"
          className="cchat-launcher-btn cchat-launcher-btn-secondary"
          onClick={() => openModal('user')}
          aria-label={
            userSignedIn ? userLabel : `${userLabel}（会員登録が必要です）`
          }
        >
          <img
            src={userIconSrc}
            alt=""
            aria-hidden="true"
            className="cchat-launcher-icon"
          />
          <span>{userLabel}</span>
        </button>
      )}
      {modalState && (
        <CircleChat
          templateType={templateType}
          circleId={circleId}
          canManage={modalState.mode === 'creator'}
          onClose={closeModal}
        />
      )}
    </>
  );
}
